module.exports = __webpack_public_path__ + "img/union.b4af267d.jpg";